import "./ServiceCard.css";

export function ServiceCard({ title, image }: { title: string; image: string }) {
  return (<div className="card" >
        <div className={"card-icon " + image}></div>
        {title}
    </div>);
}